import React from 'react';

const TranslatableText = ({ 
  text, 
  as: Component = 'span', 
  className = '', 
  children,
  ...props 
}) => {
  // With the new direct DOM manipulation approach, 
  // TranslatableText components just render their content normally.
  // Translation happens at the page level via direct DOM manipulation.
  
  const displayText = text || children;

  return (
    <Component className={className} {...props}>
      {displayText}
    </Component>
  );
};

export default TranslatableText;